<template>
  <div>
    <el-alert
      title="只显示已受理、生产中、已中断且已有物料需求的工单。已领取领料/移库数量，分仓显示可用库存。可按库存多仓拆分生成领料草稿。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="orderCode" clearable placeholder="工单编号" style="width:180px" @keyup.enter.native="loadBoard" />
      <el-button type="primary" :loading="loading" @click="loadBoard">刷新齐套看板</el-button>
    </div>
    <el-table :data="orders" border v-loading="loading" row-key="orderId">
      <el-table-column type="expand">
        <template slot-scope="{ row }">
          <el-table :data="row.lines || []" border size="small">
            <el-table-column prop="productNumber" label="物料编码" width="130" />
            <el-table-column prop="productName" label="物料名称" min-width="140" />
            <el-table-column label="替代" width="70" align="center">
              <template slot-scope="l">{{ l.row.useSubstitute ? '是' : '' }}</template>
            </el-table-column>
            <el-table-column prop="requiredQty" label="需求" width="90" align="right" />
            <el-table-column prop="issuedQty" label="已领/在途单" width="110" align="right" />
            <el-table-column prop="remainingQty" label="待领" width="90" align="right" />
            <el-table-column prop="stockQty" label="可用合计" width="100" align="right" />
            <el-table-column label="分仓库存" min-width="160">
              <template slot-scope="l">
                <span v-if="!(l.row.warehouseStocks && l.row.warehouseStocks.length)" style="color:#909399">-</span>
                <el-tag v-for="w in (l.row.warehouseStocks || [])" :key="w.wareHouseId" size="mini" style="margin:2px">
                  {{ w.wareHouseName || w.wareHouseId }}: {{ w.usableQty }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="缺料" width="90" align="right">
              <template slot-scope="l">
                <span :style="{ color: Number(l.row.shortageQty) > 0 ? '#F56C6C' : '' }">{{ l.row.shortageQty }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="单位" width="70" />
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="orderCode" label="工单编号" width="160" />
      <el-table-column prop="orderName" label="工单名称" min-width="140" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">{{ stateMap[row.orderState] || row.orderState }}</template>
      </el-table-column>
      <el-table-column prop="productNumber" label="产品" width="140" />
      <el-table-column prop="plannedQty" label="计划量" width="90" align="right" />
      <el-table-column label="齐套" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="kitType(row.kitState)">{{ kitLabel(row.kitState) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="totalRemaining" label="待领合计" width="100" align="right" />
      <el-table-column label="缺料合计" width="100" align="right">
        <template slot-scope="{ row }">
          <span :style="{ color: Number(row.totalShortage) > 0 ? '#F56C6C' : '' }">{{ row.totalShortage }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" :loading="row._issuing" @click="multiIssue(row)">多仓领料</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { kitBoard } from '../../api/materialCoverage'
import { generateIssueMulti } from '../../api/stockDocument'

export default {
  data() {
    return {
      orderCode: '',
      orders: [],
      loading: false,
      stateMap: { '01': '已受理', '02': '生产中', '05': '已中断' }
    }
  },
  created() { this.loadBoard() },
  methods: {
    loadBoard() {
      this.loading = true
      kitBoard(this.orderCode || undefined).then(res => {
        this.orders = (res.data && res.data.orders) || []
      }).finally(() => { this.loading = false })
    },
    multiIssue(row) {
      this.$confirm('按分仓库存贪心拆分生成领料草稿，继续？', '提示', { type: 'warning' }).then(() => {
        this.$set(row, '_issuing', true)
        generateIssueMulti(row.orderId).then(res => {
          const count = (res.data && res.data.count) || 0
          this.$message.success('已生成 ' + count + ' 张领料草稿')
          this.loadBoard()
        }).finally(() => { this.$set(row, '_issuing', false) })
      }).catch(() => {})
    },
    kitLabel(s) {
      return ({ COVERED: '齐套', PARTIAL: '部分', SHORT: '缺料', NONE: '-' })[s] || s
    },
    kitType(s) {
      return ({ COVERED: 'success', PARTIAL: 'warning', SHORT: 'danger' })[s] || 'info'
    }
  }
}
</script>
